import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col justify-center items-center text-center px-4 py-12 md:py-20 overflow-hidden bg-hero-gradient" data-id="element-66">
      {/* Background Glow Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-brand-purple-light/10 blur-[120px] rounded-full pointer-events-none" data-id="element-67" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="relative z-10 max-w-4xl mx-auto" data-id="element-68">
        <span className="inline-block py-1 px-3 rounded-full bg-brand-purple-light/10 border border-brand-purple-light/30 text-brand-purple-light text-sm font-semibold mb-6 tracking-wide uppercase" data-id="element-69">
          Biohacking para la Mujer Argentina
        </span>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-6 text-brand-text-primary drop-shadow-sm" data-id="element-70">
          La Razón Científica por la que{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-orange to-brand-purple-light" data-id="element-71">
            Hacés Todo Bien
          </span>
          ... y tu Cuerpo Igual No Responde
        </h1>

        <p className="text-lg md:text-xl text-brand-text-muted mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-72">
          El primer protocolo de biohacking diseñado para el cuerpo femenino
          argentino. Sincronizá tu alimentación, tu entrenamiento y tu descanso
          con tu ciclo de 28 días.{' '}
          <span className="text-brand-text-primary font-semibold" data-id="element-73">
            Sin dietas extremas. Sin cardio infinito. Con resultados reales.
          </span>
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-74">
          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} className="neon-cta bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-xl md:text-2xl py-4 px-8 md:px-12 rounded-full transition-all duration-300 uppercase tracking-wide" data-id="element-75">
            <span className="cta-text-iridescent" data-id="element-76">
              QUIERO SINCRONIZAR MI CICLO HOY
            </span>
          </motion.button>

          <img src="https://cdn.magicpatterns.com/uploads/dSwhv8LX4XCDuBiv7H4drf/mockup.png" alt="Código Hormonal - Ebook + Bonos" className="mt-6 w-full max-w-lg md:max-w-xl drop-shadow-xl" data-id="element-77" />
        </div>
      </motion.div>
    </section>;
}